export enum Themes {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export const THEMES_VALUES = Object.keys(Themes).map(key => Themes[key as keyof typeof Themes]);
